export default __webpack_public_path__ + "static/media/healthData.00e20c13.svg";